import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import "./datagrid.scss";

export const MatDataGrid = ({
  controlId,
  columns,
  data,
  sortModel,
  columnGroupingModel,
}) => {
  const NoRowsFoundMessage = () => {
    return (
      <div style={{ textAlign: "center", padding: "16px" }}>
        No records found.
      </div>
    );
  };

  return (
    <div className="dataGridMain flex-fill w-100">
      <DataGrid
        // initialState={{
        //   sorting: {
        //     sortModel: sortModel,
        //   },
        // }}
        rows={data}
        columns={columns}
        disableSelectionOnClick
        getRowId={(row) => row[controlId]}
        disableColumnMenu={true}
        components={{
          NoRowsOverlay: NoRowsFoundMessage,
        }}
        localeText={{
          noRowsLabel: "", // Set an empty string to hide the default message
        }}
        experimentalFeatures={{ columnGrouping: true }}
        columnGroupingModel={columnGroupingModel}
        hideFooter
        hideFooterPagination
      />
    </div>
  );
};
